<template>
	<!--
		`not-prose` keeps the typography plugin from styling the insides of our own
		components, and the margin gives the elements similar spacing as other
		block-level elements within rich text fields. Otherwise embedded videos and
		similar would otherwise look different than they'd look outside of rich
		text context.
	-->
	<div class="not-prose my-8">
		<!-- From @storyblok/vue -->
		<storyblok-component
			v-for="(blok, index) in body"
			:key="blok._uid ?? index"
			:blok="blok"
		/>
	</div>
</template>

<script setup lang="ts">
/*
 * Custom handler for our own components inside rich text.
 */
import type {SbVueRichTextProps} from "@storyblok/vue";

// eslint-disable-next-line vue/prop-name-casing -- Lint issues come from the library
const properties = defineProps<SbVueRichTextProps["blok"]>();

const body = computed(
	() => properties.attrs?.body?.filter((blok) => blok.component) ?? [],
);
</script>
